import { Component, For, Show } from "solid-js"
import { cleanImagePath } from "./API"
import { ArtworkLocation } from "./Types";

type Props = {
    data: ArtworkLocation;
}

export const MoreImagesTab : Component<Props> = ({ data }) => {
    const megapixels = (height: number|undefined, width: number|undefined) => {
        if (!height || !width) return "";
        const mp = Math.round(height * width / 1000000);
        return mp < 1 ? "less than 1 MP" : mp > 1 ? mp + " MPs" : "1 MP";
    }
    return (
        <div class="otherimages" style="background-color: #000;">
            <For each={data.Images}>{(item) =>
                <div class="otherimages-cell">
                    <a href={ "/Common/Image?imageId=" + item.Id }>
                        <img
                            src={cleanImagePath(item.URL)+"?mode=max&width=600&anchor=topLeft"}
                            class="no-clicky-for-you zoomable"
                            style="width: 400px; height: auto;"
                        />
                    </a>
                    <div style="background-color: #000; color: #fff; padding: 5px;">
                        <div>
                            <p style="font-size: 0.75rem;">
                                {item.Height} x {item.Width} pixels <span class="hd">{megapixels(item.Height, item.Width)}</span>
                            </p>
                            <Show when={item.FileSizeBytes > 0}>
                                <p style="font-size: 0.75rem;">
                                    {Math.floor(item.FileSizeBytes / 1024)} KBs
                                </p>
                            </Show>
                        </div>
                    </div>
                </div>
            }</For>
        </div>
    )
}